import { Pane, Text } from '@leverege/ui-elements'
import { ParentSize } from '@visx/responsive'
import {
  AnimatedAxis,
  AnimatedBarSeries,
  DataProvider,
  Tooltip,
  XYChart,
} from '@visx/xychart'
import React from 'react'

import { alertsChartTheme } from '../../../../util/Theme'
import GenericTooltip from '../../views/GenericTooltip'
import S from '../Alerts.css'
import useAlertsBarChart from '../hooks/useAlertsBarChart'

export default function AlertsBarChart( props ) {
  const { data, config } = useAlertsBarChart( props )
  return (
    <Pane variant="cardNoPad" layout="flex:col" className={S.chart2}>
      <div
        style={{
          height : '60px',
          padding : 'var(--size-padLarge)',
          borderBottom : '1px solid var(--color-base100)',
        }}>
        <Text variant="subtitle">Alert Counts By Type</Text>
      </div>
      <div
        style={{
          height : 'calc(100% - 60px)',
          padding :
            '0 var(--size-padLarge) var(--size-padLarge) var(--size-padLarge)',
        }}>
        <ParentSize
          parentSizeStyles={{
            position : 'relative',
            overflow : 'hidden',
            width : '100%',
            height : '100%',
          }}>
          {( { width, height } ) => (
            <DataProvider
              theme={alertsChartTheme}
              xScale={config.scale.x}
              yScale={config.scale.y}>
              <XYChart width={width} height={height - 20}>
                <AnimatedAxis
                  orientation="left"
                  numTicks={6}
                  label="Number of Alerts"/>
                <AnimatedAxis
                  label="Type"
                  tickFormat={config.tickFormat.x}
                  orientation="bottom"
                  numTicks={data.length}/>
                {data.map( item => (
                  <AnimatedBarSeries
                    key={item?.id}
                    data={data.map( v => ( { [item.id] : v } ) )}
                    dataKey={item?.id}
                    {...config?.accessors?.[item?.id]}/>
                ) )}
                <Tooltip
                  scroll
                  detectBounds
                  snapTooltipToDatumX={false}
                  snapTooltipToDatumY={false}
                  renderTooltip={props => (
                    <GenericTooltip {...props} config={config} />
                  )}/>
              </XYChart>
            </DataProvider>
          )}
        </ParentSize>
      </div>
    </Pane>
  )
}
